import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamCustomerService01Icon,
  ShamCustomerServiceIcon,
  ShamDashboardSquare01StrokeIcon,
  ShamSettingsIcon,
  ShamWhiteboardIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(
  dashData: ShamDashboardData,
  translate: any,
) {
  dashData.navLinks.set([
    {
      name: translate.instant('menu.new_ticket'),
      paths: 'new-ticket',
      icon: ShamWhiteboardIcon,
    },
    'hr',
    {
      name: translate.instant('menu.dashboard'),
      paths: 'dashboard',
      icon: ShamDashboardSquare01StrokeIcon,
    },
    {
      name: translate.instant('menu.cs_team'),
      paths: 'cs-team',
      icon: ShamCustomerServiceIcon,
    },
    {
      name: 'General Settings',
      paths: 'general-settings',
      icon: ShamSettingsIcon,
    },
  ]);
}
